<script setup lang="ts">
import type { Tone, ToneGlyph } from '@/lib/tone'
import ToneGlyphIcon from './ToneGlyph.vue'

defineProps<{
  tone: Tone
  glyph: ToneGlyph
  label: string
  count?: number
}>()
</script>

<template>
  <span
    class="tone-chip"
    :data-tone="tone"
  >
    <ToneGlyphIcon :glyph="glyph" />
    {{ label }}
    <span
      v-if="typeof count === 'number'"
      class="tabular"
    >{{ count }}</span>
  </span>
</template>
